global.msgError = ''
// global.API_URL = 'http://localhost:5005/'

global.API_URL = 'https://servereb.impintsys.com/'


